import { Column } from "@/components/Table/Table";

export const EMPLOYEE_COMMUTE_UPLOAD_COLUMNS: Column[] = [
  {
    label: "Employee ID",
    key: "external_id",
    searchable: true,
    minWidth: "170px",
  },
  {
    label: "Year",
    key: "date",
    sortable: true,
  },
  {
    label: "Country",
    key: "country",
    searchable: true,
    minWidth: "168px",
  },
  {
    label: "Travel mode",
    key: "travel_mode",
    searchable: true,
    minWidth: "170px",
  },
  {
    label: "Total km",
    key: "distance",
    sortable: true,
    minWidth: "140px",
  },
  {
    label: "Owned or leased",
    key: "owned",
    sortable: true,
    minWidth: "200px",
  },
];
